<template>
  <v-container class="pa-3" fluid>
    <v-card class="pa-6">
      <v-row>
        <v-col cols="12" md="6">
          <v-card-title class="text-h5">Attendant Report</v-card-title>
        </v-col>
        <v-col align="right" color="primary" cols="12" md="6"> </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-autocomplete v-model="datasearch.employeename" :items="emp_list" item-text="name" item-value="id"
            label="Employee Name" clearable @click:clear="
              $nextTick(() => {
                datasearch.employeename = '';
              })
              " outlined dense></v-autocomplete>
          <!-- <v-text-field
                  v-model="datasearch.employeename"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  outlined
                  dense
                ></v-text-field> -->
        </v-col>
        <v-col cols="12" md="4">
          <v-autocomplete clearable @click:clear="
            $nextTick(() => {
              datasearch.department = 0;
            })
            " v-model="datasearch.department" :items="department_list" label="Department" item-text="department_name"
            item-value="id" outlined dense @change="OnSearchDepartment"></v-autocomplete>
        </v-col>
      </v-row>
      <!-- <v-col cols="12" md="4">
            <v-autocomplete
              v-model="datasearch.customername"
              :items="customer_list"
              item-text="name"
              item-value="name"
              label="Client Name"
              clearable
              @click:clear="
                $nextTick(() => {
                  datasearch.customername = '';
                })
              "
              outlined
              dense
            ></v-autocomplete>
          </v-col> -->
      <v-row>
        <v-col cols="12" md="4">
          <v-menu v-model="menudatefrom" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="computedDateFromFormatted" label="DateFrom" append-icon="mdi-calendar" readonly
                dense outlined v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="datasearch.datefrom" @input="menudatefrom = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="4">
          <v-menu v-model="menudateto" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="computedDateToFormatted" label="DateTo" append-icon="mdi-calendar" readonly dense
                outlined v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="datasearch.dateto" @input="menudateto = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="2">
          <v-btn @click="SearchAlldata">
            <v-icon left>mdi-magnify</v-icon> Search</v-btn>
        </v-col>
      </v-row>

      <template>
        <div id="mydivhtmltobase">
          <div v-for="index in datashowAll.length" v-if="datashowAll.length >= 0 || pageAll >= 0">
            <div class="aligncenter" id="foo">
              <page size="A4" class="aligncenter">
                <div class="aligncenter">
                  <div class="rowprpo ">
                    <div class="col-md-6report"></div>
                    <div class="col-md-6report">
                      <p class="alignright  colprpo mr30prpo mt30">
                        Page : {{ index }}
                      </p>
                    </div>
                  </div>
                  <div class="rowprpo aligncenter" style="color:blue;">
                    <div class="col-md-12report mt-30prpo">
                      <h2>
                        {{ dataformatpr.title }}
                      </h2>
                    </div>
                  </div>
                  <div class="rowprpo  aligncenter" style="color:red;">
                    <div class="col-md-12report">
                      <h3>
                        {{ dataformatpr.subtitle }}
                      </h3>
                    </div>
                  </div>
                  <!-- <div class="rowprpo  aligncenter">
                    <div class="col-md-12report">
                      <h4>
                        {{ dataformatpr.paymenttype }} :
                        {{ showchargetype }}
                      </h4>
                    </div>
                  </div> -->
                </div>

                <div class="rowprpo caption  ml30prpo mr30prpo" style="margin-top:10px">
                  <table class="captionhtable ">
                    <tr>
                      <th scope="colgroup" class="prbordertop2pxhtable  width20">
                        <span class="alignleft">รหัส </span>
                      </th>

                      <th scope="colgroup" class="prbordertop2pxhtable  width80">
                        <span class="alignleft">ชื่อพนักงาน </span>
                      </th>
                    </tr>
                  </table>

                  <table class="captionhtable ">
                    <tr>
                      <th scope="colgroup" class=" prborderbottom2pxhtable width20">
                        <span class="alignleft">วันที่ </span>
                      </th>

                      <th scope="colgroup" class=" prborderbottom2pxhtable width10">
                        <span class="alignleft">เวลาเข้า </span>
                      </th>
                      <th scope="colgroup" class=" prborderbottom2pxhtable width10">
                        <span class="alignleft">เวลาออก </span>
                      </th>
                      <th scope="colgroup" class=" prborderbottom2pxhtable width60">
                        <span class="aligncenter">หมายเหตุ </span>
                      </th>
                    </tr>
                    <!-- <tr>
                            <th scope="col" class="prborderbottom">No.</th>
                            <th scope="col" class="prborderbottom">Item Number</th>
                            <th scope="col" class="prborderbottom">Description</th>
                            <th scope="col" class="prborderbottom">Quality</th>
                            <th scope="col" class="prborderbottom">Unit</th>
                          </tr> -->

                    <!-- <tr
                            v-for="(data, i) in setdatatoshow[index - 1]"
                            id="content"
                            class=""
                          >
                            <td class="width10">
                              <span class="alignleft">{{ data.no }}</span>
                            </td>
                            <td class="width20" colspan="2">
                              <span class="alignleft"> {{ data.checkInDate }}</span>
                            </td>
                            style="white-space: pre-line"
                            <td class="width10">
                              <span class="alignleft">PM</span>
                            </td>
                            <td class="width10">
                              <span class="alignleft">{{ data.duration }}</span>
                            </td>
                            <td class="width50">
                              <span class="alignleft"> {{ data.detail }}</span>
                            </td>
                          </tr> -->
                  </table>
                </div>

                <div v-for="(data, i) in datashowAll[index - 1]" id="content" class="">
                  <div class="rowprpo ml30prpo mr30prpo " v-if="i == 0 && data.no == 1">
                    <div class="width20 fixonerow">
                      <h4 class="alignleft ">
                        <span v-if="data.showcustomer_id">
                          {{ data.showcustomer_id }}</span>
                        <span v-else> -</span>
                      </h4>
                    </div>
                    <div class="width80 fixonerow">
                      <h4 class="alignleft">
                        <span v-if="data.showfullname_en">
                          {{ data.showfullname_th }}</span>
                        <span v-else> -</span>
                      </h4>
                    </div>
                  </div>

                  <div class="rowprpo ml30prpo mr30prpo " v-if="data.firstiteminpage">
                    <div class="width20 fixonerow">
                      <h4 class="alignleft ">
                      </h4>
                    </div>
                    <div class="width80 fixonerow">
                      <h4 class="alignleft">
                        <span v-if="data.checkInDate">
                          {{ monthnameAll[Number(data.checkInDate.split("/")[1])] }}</span>
                        <span v-else> -</span>
                      </h4>
                    </div>

                  </div>

                  <!-- <div
                          class="rowprpo ml30prpo mr30prpo mt10 "
                          v-if="i == 0 && data.no == 1"
                        >
                          <div class="width10 fixonerow">
                            <h4 class="alignleft"></h4>
                          </div>
                          <div class="width90 fixonerow">
                            <h4 class="alignleft">
                              changedepartment
                              <span v-if="data.department_name"  >
                                {{ data.department_name }}</span
                              >
                              <span v-else> -</span>
                            </h4>
                          </div>
                        </div> -->
                  <div class="rowprpo ml30prpo mr30prpo mt10 " v-if="data.changedepartment">
                    <div class="width20 fixonerow">
                      <h4 class="alignleft"></h4>
                    </div>
                    <div class="width80 fixonerow">
                      <h4 class="alignleft">
                        <span v-if="data.job_name"> {{ data.job_name }}</span>
                        <span v-else> </span>
                      </h4>
                    </div>
                  </div>

                  <div class="rowprpo ml30prpo mr30prpo captionreport">
                    <!-- <div class="width10 textalignleft">
                      {{ data.no }}
                    </div> -->
                    <div class="width20 textalignleft" colspan="2">
                      {{ data.checkInDate }}
                    </div>
                    <!-- style="white-space: pre-line" -->
                    <div class="width10 textalignleft">
                      <span v-if="data.timecheckInDate">{{
                        data.timecheckInDate
                      }}</span>
                      <span v-else>-</span>
                    </div>
                    <div class="width10 textalignleft">
                      <span v-if="data.timecheckOutDate">{{
                        data.timecheckOutDate
                      }}</span>
                      <span v-else>-</span>
                    </div>
                    <div v-if="data.detail == '(วันเสาร์)' || data.detail == '(วันอาทิตย์)'"
                      class="width60 textalignleft color-orange">
                      {{ data.detail }}
                    </div>
                    <div v-else class="width60 textalignleft">
                      {{ data.detail }}
                    </div>
                  </div>
                  <!-- <div
                    class="rowprpo ml30prpo mr30prpo "
                    v-if="data.lastdata == 'lastindex'"
                  >
                    <div class="width10 fixonerow">
                      <h4 class="alignleft "></h4>
                    </div>
                    <div class="width30 fixonerow">
                      <h4 class="alignleft">
                        Total Client
                      </h4>
                    </div>
                    <div class="width60 fixonerow">
                      <h4 class="alignleft">
                        {{ data.totalclient }}
                      </h4>
                    </div>
                  </div> -->
                </div>
              </page>
            </div>
          </div>
        </div>
      </template>
      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card-actions class="mt-5">
        <v-spacer></v-spacer>

        <v-btn v-if="this.datashowAll.length > 0" depressed outlined buttonred width="100" @click="exportToPDF">
          print
        </v-btn>

        <v-spacer></v-spacer>
      </v-card-actions>

      <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />

      <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message" :link="link" />
    </v-card>
  </v-container>
</template>

<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "../services/constants";
import html2pdf from "html2pdf.js";
import unity from "@/unity/unity";

export default {
  async mounted() {
    // this.$showLoader();
    await api.checkVersion();
    this.mycompany_id = localStorage.getItem(server.COMPANYID);
    this.loadEmp();
    this.loadCustomer();
    this.loadJobtitle();
    await this.loadDepartmentByCompanyId();
    await this.loadCompany();
    setTimeout(() => {
      this.$hideLoader();
    }, 500);
  },
  components: {
    SuccessDialog,
  },
  computed: {
    computedDateFromFormatted() {
      return unity.formatDate(this.datasearch.datefrom);
    },
    computedDateToFormatted() {
      return unity.formatDate(this.datasearch.dateto);
    },
  },
  data() {
    return {
      monthnameAll: ['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      showchargetype: "",
      checkdepartmentname: "",
      lengthAlldatasearch: 0,
      menudateto: false,
      menudatefrom: false,
      mycompany_id: 0,
      datasearch: {
        employeename: "",
        department: 0,
        // datefrom: "",
        // dateto: "",
        datefrom: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        dateto: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        // company_id: 13,
        company_id: localStorage.getItem(server.COMPANYID),
      },
      getnamesignature: [],
      prpoheader: [],
      memoref_list: [],
      no_list: [],
      mysignature: "",
      approvesignature: "",
      opensummarize: false,
      datashowAll: [],
      setdatatoshow: [],
      dataforshowprpo: [
        // {
        //   DESCRIPTION: "Procurement - Tunnel",
        //   DIMENSION2_: "ENG-PJ-EP-21-007",
        //   ITEMID: "EN21007002",
        //   IVZ_BUDGETACCOUNT: "BEEQP-EN21007002",
        //   IVZ_BUDGETMODELID: "PJEP21-007",
        //   NAME:
        //     "Procurement - Tunnel\nค่าอากรขาเข้า \nค่าภาษีมูลค่าเพิ่ม \n\nRef No : 39280\nDate : 16/08/2565\nPP Business Coporation\n**ดำเนินการแล้วเสร็จ**",
        //   PURCHQTY: 1,
        //   PURCHREQID: "PR22-004569",
        //   PURCHUNIT: "ea",
        // },
      ],
      getheightcontentpr: 0,
      pageAll: 1,
      previewattachimage: "",
      dataformatpr: {
        title: "",
        subtitle: "Time Sheet Monthly Report",
        paymenttype: "Payment Type",
        companyname_addressrow1:
          "เลขที่ 142 อาคาร ทู แปซิฟิค เพลส ชั้น20 ถนนสุขุมวิท แขวงคลองเตย",
        companyname_addressrow2: "เขตคลองเตย กรุงเทพฯ 10110",
        pr_number: "เลขที่ใบขอซื้อ/PR Number",
        pr_date: "วันที่/PR Date",
        companyname_tel: "โทรศัพท์/Tel. 02-6530489-9",
        companyname_fax: "โทรสาร/Fax. 02-6533706",
        prtitle_th: "ใบขอซื้อ",
        prtitle_en: "PURCHASE REQUISTION",
      },
      dataformatprdetail: {
        project: "โครงการ/Project",
        department: "แผนก/Department",
        requist_date: "วันที่ต้องการ/Requist date",
        type: "ประเภท/Type",
        date_period: "วันที่เริ่มต้น-สิ้นสุด/Date period",
        objective: "วัตถุประสงค์/PR Name",
        vender: "ชื่อผู้จำหน่าย/Vender",
      },
      department_list: [],
      charge_list: [
        { value: "T/C", name: "Time Charge" },
        { value: "N/C", name: "No Charge" },
        { value: "F/C", name: "Fix Charge" },
        { value: "OFF", name: "ทำงานออฟฟิต" },
      ],
      isShowPassword: false,
      fullPage: true,
      dialogEdit: false,
      dialogDelete: false,
      dialogAdd: false,
      dialogSendMail: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      closeDelete: false,
      deleteItemConfirm: false,
      emp_list: [],
      jobtitle_list: [],
      customer_list: [],
    };
  },
  methods: {
    async loadEmp() {
      const result = await api.getAccountslist_by_ComID(
        localStorage.getItem(server.COMPANYID)
      );

      this.emp_list = result.data;
    },
    async loadJobtitle() {
      const result = await api.getAllJobtitleByCompany(
        localStorage.getItem(server.COMPANYID)
      );

      this.jobtitle_list = result.data;
    },
    async loadCustomer() {
      const result = await api.getAllCustomerListByCompany(
        localStorage.getItem(server.COMPANYID)
      );
      this.customer_list = result.data;
    },
    async loadCompany() {
      let copany_datat = await api.getCompanyByID(localStorage.getItem(server.COMPANYID));
      this.dataformatpr.title = copany_datat.data[0].name;
    },
    async loadDepartmentByCompanyId() {
      let result = await api.getNewAllDepartment_By_CompanyID(this.mycompany_id);

      this.department_list = result.data;
    },
    findChaege(chargetype) {
      this.charge_list.filter((item, index) => {

        if (item.value == chargetype) {
          this.showchargetype = item.name;
          return;
        }
      });
    },
    async OnSearchDepartment() {
    },
    async SearchAlldata() {
      this.datashowAll = [];
      // if (!this.datasearch.chargetype) {
      //   this.$store.state.global_dialog = true;
      //   this.setupAlertDialog(
      //     true,
      //     "ค้นหาข้อมูล",
      //     "กรุณาเลือก ChargeType",
      //     "text-h5 red--text text-center"
      //   );
      //   return;
      // }
      if (!this.datasearch.datefrom) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateFrom",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (!this.datasearch.dateto) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateTo",
          "text-h5 red--text text-center"
        );
        return;
      }
      this.lengthAlldatasearch = 0;
      this.datashowAll = [];
      let resultcheckuserid = [];
      let haveemployee = false;
      if (this.datasearch.employeename == "") {
        haveemployee = false;
        resultcheckuserid = await api.getcheckattendantuserid({
          params: this.datasearch,
        });
        if (resultcheckuserid.data.length == 0) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "ค้นหาข้อมูล",
            "ไม่มีข้อมูล",
            "text-h5 red--text text-center"
          );
          return;
        }

        this.datasearch.employeename = "";
      } else {
        haveemployee = true;

        resultcheckuserid.data = [{ userId: this.datasearch.employeename }];
      }
      resultcheckuserid.data.forEach(async (x) => {
        this.datasearch.employeename = parseInt(x.userId);
        const result = await api.getActivityattendantreport({
          params: this.datasearch,
        });
        console.log(result.data);
        if (result.data[0].length > 0) {
          this.emp_list.map((emp) => {
            if (x.userId == emp.id) {
              result.data[0][0].showfullname_en = emp.fullname_en;
              result.data[0][0].showfullname_th = emp.fullname_th;
              result.data[0][0].showcustomer_id = emp.id;
            }
          });
        }

        if (haveemployee == false) {
          this.datasearch.employeename = "";
        }

        // this.dataforshowprpo = result.data;
        // console.log(result.data);

        this.lengthAlldatasearch = result.data.length;
        let getdata = result.data;
        let settimehour = 9;
        for (let i = 0; i < this.lengthAlldatasearch; i++) {
          getdata[i].forEach(async (x, index) => {
            if (
              x.id == null &&
              x.checkInDate2 == null &&
              x.timecheckOutDate == null
            ) {
              // console.log("if");
              if (x.checkdateweek == 5) {
                x.detail = `(วันเสาร์)`;
              } else if (x.checkdateweek == 6) {
                x.detail = `(วันอาทิตย์)`;
              } else {
                x.detail = "ไม่ได้สแกนเข้า";
              }
              if (x.leave_date) {
                x.detail = '';
                x.detail += ` (ลางาน ${x.leave_status_detail})`;
                if (parseFloat(x.leave_hour) > 0) {
                  x.detail += ` (${x.leave_hour.split(".")[0] > 0
                      ? x.leave_hour.split(".")[0] + "ชั่วโมง "
                      : ""
                    }${x.leave_hour.split(".")[1] > 0
                      ? parseFloat("0." + x.leave_hour.split(".")[1]) * 60 +
                      "นาที"
                      : ""
                    })`;
                }
              }
            } else if (
              x.id !== null &&
              x.checkInDate2 !== null &&
              x.timecheckOutDate == null
            ) {
              // console.log("else if");
              x.detail = "ไม่สแกนออก";
            } else {
              // console.log("else");
              //     if (
              //     parseFloat(x.days * 24) +
              //       parseFloat(x.hours) +
              //       parseFloat(x.minutes) +
              //       parseFloat(x.leave_hour) <
              //     settimehour
              //   )
              if (!x.timecheckInDate && x.leave_date && x.leave_hour) {
                x.detail = `ลางาน`;
                if (parseFloat(x.leave_hour) > 0) {
                  x.detail += ` (${x.leave_hour.split(".")[0] > 0
                      ? x.leave_hour.split(".")[0] + "ชั่วโมง "
                      : ""
                    }${x.leave_hour.split(".")[1] > 0
                      ? parseFloat("0." + x.leave_hour.split(".")[1]) * 60 +
                      "นาที"
                      : ""
                    })`;
                }
                return;
              }
              let timeall =
                parseFloat(x.days * 24) +
                parseFloat(x.hours) +
                parseFloat(x.minutes) +
                parseFloat(x.leave_hour);
              // console.log(timeall);

              // let timediff = settimehour - timeall;
              // let hourdiff = timediff.toString().split(".")[0];
              // hourdiff = parseInt(x.hours) + parseInt(hourdiff);
              // let minutediff = "0." + timediff.toString().split(".")[1];
              // minutediff = (parseFloat(x.minutes) + parseFloat(minutediff)) * 60;
              let gettimetonumber = parseFloat(
                x.timecheckInDate.replace(":", ".")
              );
              let datecheckout = parseFloat(
                gettimetonumber + settimehour
              ).toFixed(2);
              // let datecheckcurrent = parseFloat(
              //   x.timecheckOutDate.replace(":", ".")
              // ).toFixed(2);
              // console.log(datecheckout + " +" + datecheckcurrent);
              // let hourdiff = datecheckout - datecheckcurrent;
              // hourdiff = hourdiff.toString().split(".")[0];
              // let minutediff =
              //   parseFloat(datecheckout) - parseFloat(datecheckcurrent);
              // console.log("hourdiff" + hourdiff);
              // console.log("minutediff" + minutediff);
              // let settimecheckin = parseFloat(
              //   x.timecheckInDate.replace(":", ".") + settimehour
              // ).toFixed(2);
              let sethourmore = Math.floor(datecheckout / 24);
              let setminutemore = datecheckout - sethourmore * 24;
              // console.log(setminutemore);

              const [cutday, cutmonth, cutyear] = x.checkInDate.split("/");
              let setnewcheckindate = `${cutyear}-${cutmonth.padStart(
                2,
                "0"
              )}-${cutday.padStart(2, "0")}`;
              let setcreatenewdate = new Date(setnewcheckindate);

              setcreatenewdate.setDate(
                setcreatenewdate.getDate() + sethourmore
              );

              let getsetcheckInDate = new Date(
                setcreatenewdate - new Date().getTimezoneOffset() * 60000
              )
                .toISOString()
                .substr(0, 10);
              const [toyear, tomonth, today] = getsetcheckInDate.split("-");
              let newdatecheckin = `${today.padStart(
                2,
                "0"
              )}/${tomonth.padStart(2, "0")}/${toyear}`;

              let setdatecheckin = `${this.formatDatetomonthdayyear(
                newdatecheckin
              )} ${setminutemore
                .toFixed(2)
                .toString()
                .replace(".", ":")
                .toString()}:00`;

              let setdatecheckout = `${this.formatDatetomonthdayyear(
                x.checkOutDate
              )} ${x.timecheckOutDate}:00`;
              var date1 = new Date(setdatecheckin);
              var date2 = new Date(setdatecheckout);
              // console.log(date1);
              // console.log(date2);
              var date1checkdate = new Date(setdatecheckin).toLocaleDateString('en-CA');
              var date2checkdate = new Date(setdatecheckout).toLocaleDateString('en-CA');
              // console.log(date1checkdate);
              // console.log(date2checkdate);

              var diff = date2.getTime() - date1.getTime();

              var msec = diff;
              var hh = Math.floor(msec / 1000 / 60 / 60);
              msec -= hh * 1000 * 60 * 60;
              var mm = Math.floor(msec / 1000 / 60);
              msec -= mm * 1000 * 60;
              var ss = Math.floor(msec / 1000);
              msec -= ss * 1000;

              var date11 = new Date(setdatecheckin);
              var date22 = new Date(setdatecheckout);
              var difff = date11.getTime() - date22.getTime();

              var msecc = difff;
              var hhh = Math.floor(msecc / 1000 / 60 / 60);
              msecc -= hhh * 1000 * 60 * 60;
              var mmm = Math.floor(msecc / 1000 / 60);
              msecc -= mmm * 1000 * 60;
              var sss = Math.floor(msecc / 1000);
              msecc -= ss * 1000;

              // console.log(parseInt(hh));
              // console.log(settimehour);
              // if (parseInt(hh) < 0) {
              if (x.leave_hour) {
                hhh = hhh - parseFloat(x.leave_hour)
              }
              if (parseInt(hhh) > 0) {
                x.detail = `ขาดงาน`;
                // if (parseInt(hh) < 0) {
                if (parseInt(hhh) > 0) {
                  // x.detail += ` ${Math.abs(hh) - 1} ชั่วโมง`;
                  x.detail += ` ${Math.abs(hhh)} ชั่วโมง`;
                }
                if (mmm > 0) {
                  x.detail += ` ${mmm} นาที`;
                }
                if (parseFloat(x.leave_hour) > 0) {
                  x.detail += ` (ลางาน) (${x.leave_hour.split(".")[0] > 0
                      ? x.leave_hour.split(".")[0] + "ชั่วโมง "
                      : ""
                    }${x.leave_hour.split(".")[1] > 0
                      ? parseFloat("0." + x.leave_hour.split(".")[1]) * 60 +
                      "นาที"
                      : ""
                    })`;
                }
              } else if (parseInt(hhh) == 0 && mmm > 0) {
                x.detail = `ขาดงาน`;
                x.detail += ` ${mmm} นาที`;
                if (parseFloat(x.leave_hour) > 0) {
                  x.detail += ` (ลางาน) (${x.leave_hour.split(".")[0] > 0
                      ? x.leave_hour.split(".")[0] + "ชั่วโมง "
                      : ""
                    }${x.leave_hour.split(".")[1] > 0
                      ? parseFloat("0." + x.leave_hour.split(".")[1]) * 60 +
                      "นาที"
                      : ""
                    })`;
                }
              } else {
                x.detail = "-";
                if (x.leave_date) {
                  x.detail = "-";
                  if (parseFloat(x.leave_hour) > 0) {
                    x.detail = `ลางาน (${x.leave_hour.split(".")[0] > 0
                        ? x.leave_hour.split(".")[0] + "ชั่วโมง "
                        : ""
                      }${x.leave_hour.split(".")[1] > 0
                        ? parseFloat("0." + x.leave_hour.split(".")[1]) * 60 +
                        "นาที"
                        : ""
                      })`;
                  }
                }
              }

              if (date2checkdate > date1checkdate) {
                x.timecheckOutDate = "23:59";
                x.detail += ` (ตัดเวลาอัตโนมัติ)`;
              }
            }
          });
        }

        // console.log(this.dataforshowprpo);
        getdata.forEach(async (x, index) => {
          this.dataforshowprpo[0] = x;

          await this.checkcontent(this.dataforshowprpo[0]);
        });
      });
    },
    async checkcontent(data) {
      let totalclient = 0;
      // console.log("send data ====");
      // console.log(this.dataforshowprpo[0]);
      // alert(data.length);
      this.setdatatoshow = [];
      let linedetailprpo = 34;
      let datainlineprpo = 45;
      let addnewbutget = 1;
      let getdata = [];
      let getnewdata = [];
      let hllinedetails = 0;
      this.pageAll = 1;
      let newhllinedetails = 0;
      let oldcutmonthcheckcontent;

      for (let i = 0; i < this.dataforshowprpo[0].length; i++) {
        let cutdaycheckcontent;
        let cutmonthcheckcontent;
        let cutyearcheckcontent;
        let stringchecklength = "";
        let lengthofdataforshowprpo = this.dataforshowprpo[0][i].detail.length;
        // console.log(this.dataforshowprpo[0][i].checkInDate)


        let maiek = "่"; //ไม้เอก
        let maito = "้"; //ไม้โท
        let maitree = "๊"; //ไม้ตรี
        let maijattawa = "๋"; //ไม้จัตวา
        let vowelei = "ิ"; //สระอิ
        let vowelee = "ี"; //สระอี
        let voweleue = "ึ"; //สระอึ
        let voweleu = "ื"; //สระอือ
        let vowelu = "ุ"; //สระอุ
        let voweluu = "ู"; //สระอู
        let maihun = "ั"; //ไม้หันอากาศ
        let maiyamok = "็"; //ไม้เอก
        newhllinedetails = 0;
        getnewdata = [];

        [cutdaycheckcontent, cutmonthcheckcontent, cutyearcheckcontent] = this.dataforshowprpo[0][i].checkInDate.split("/");
        this.dataforshowprpo[0][i].no = i + 1;
        totalclient += parseFloat(
          this.dataforshowprpo[0][i].duration
            ? this.dataforshowprpo[0][i].duration
            : 0
        );
        if (i == 0) {
          this.checkdepartmentname = this.dataforshowprpo[0][i].job_name;
          this.dataforshowprpo[0][i].changedepartment = true;
          this.dataforshowprpo[0][i].firstiteminpage = true;
          oldcutmonthcheckcontent = cutmonthcheckcontent;
        } else {
          if (
            this.checkdepartmentname !== this.dataforshowprpo[0][i].job_name
          ) {
            this.dataforshowprpo[0][i].changedepartment = true;
            this.dataforshowprpo[0][i].firstiteminpage = true;
            this.checkdepartmentname = this.dataforshowprpo[0][i].job_name;
            hllinedetails++;
          }
          // if(cutmonthcheckcontent !== oldcutmonthcheckcontent){
          //   console.log(cutmonthcheckcontent)
          //   console.log(oldcutmonthcheckcontent)
          //   oldcutmonthcheckcontent = cutmonthcheckcontent;
          //   hllinedetails++;

          // }
        }
        stringchecklength = this.dataforshowprpo[0][i].detail;

        // let myArrayname = this.dataforshowprpo[i].NAME.split("\n");
        // for (let a = 0; a < myArrayname.length; a++) {
        //   let lengthnewline = myArrayname[a].length;
        //   for (let b = 0; b < myArrayname[a].length; b++) {
        //     if (
        //       myArrayname[a][b] == maiek ||
        //       myArrayname[a][b] == maito ||
        //       myArrayname[a][b] == maitree ||
        //       myArrayname[a][b] == maijattawa ||
        //       myArrayname[a][b] == vowelei ||
        //       myArrayname[a][b] == vowelee ||
        //       myArrayname[a][b] == voweleue ||
        //       myArrayname[a][b] == voweleu ||
        //       myArrayname[a][b] == vowelu ||
        //       myArrayname[a][b] == voweluu ||
        //       myArrayname[a][b] == maihun ||
        //       myArrayname[a][b] == maiyamok
        //     ) {
        //       lengthnewline--;
        //     }

        //   }

        for (let j = 0; j < this.dataforshowprpo[0][i].detail.length; j++) {
          if (
            stringchecklength[j] == maiek ||
            stringchecklength[j] == maito ||
            stringchecklength[j] == maitree ||
            stringchecklength[j] == maijattawa ||
            stringchecklength[j] == vowelei ||
            stringchecklength[j] == vowelee ||
            stringchecklength[j] == voweleue ||
            stringchecklength[j] == voweleu ||
            stringchecklength[j] == vowelu ||
            stringchecklength[j] == voweluu ||
            stringchecklength[j] == maihun ||
            stringchecklength[j] == maiyamok
          ) {
            lengthofdataforshowprpo--;
          }
        }
        newhllinedetails = Math.ceil(lengthofdataforshowprpo / datainlineprpo);

        // newhllinedetails = Math.ceil(
        //   this.dataforshowprpo[i].NAME.length / datainlineprpo
        // );

        // newhllinedetails += addnewbutget;
        getnewdata.push(this.dataforshowprpo[0][i]);
        // console.log(getdata.length);
        // console.log(hllinedetails + newhllinedetails + getdata.length);
        // console.log(hllinedetails);
        // console.log(newhllinedetails);
        // console.log(getdata.length);
        // console.log("=================================");
        // console.log(cutmonthcheckcontent);
        // console.log(oldcutmonthcheckcontent);
        // console.log("=================================");
        if (hllinedetails + newhllinedetails > linedetailprpo || cutmonthcheckcontent !== oldcutmonthcheckcontent) {
          oldcutmonthcheckcontent = cutmonthcheckcontent;
          this.dataforshowprpo[0][i].firstiteminpage = true;
          this.setdatatoshow[this.pageAll - 1] = getdata;
          this.pageAll++;

          hllinedetails = 0;
          getdata = [];
          getdata.push(this.dataforshowprpo[0][i]);
          hllinedetails += newhllinedetails;
          if (i == this.dataforshowprpo[0].length - 1) {
            this.dataforshowprpo[0][i].totalclient = totalclient.toFixed(2);
            this.setdatatoshow[this.pageAll - 1] = getdata;
            getdata = [];

          }
        } else {
          hllinedetails += newhllinedetails;

          getdata.push(this.dataforshowprpo[0][i]);

          if (i == this.dataforshowprpo[0].length - 1) {
            this.dataforshowprpo[0][i].totalclient = totalclient.toFixed(2);
            this.setdatatoshow[this.pageAll - 1] = getdata;
            getdata = [];
          }
        }
      }
      this.pageAll += this.lengthAlldatasearch - 1;
      this.opensummarize = true;
      // console.log(this.pageAll);
      // console.log("showwwwwwwwwwwwwwwwwwwww");
      // console.log(this.setdatatoshow);

      this.setdatatoshow.forEach((item, iitem) => {
        // console.log(item);
        // console.log(iitem + " " + this.setdatatoshow[0].length);
        if (iitem == this.setdatatoshow.length - 1) {
          item[this.setdatatoshow[iitem].length - 1].lastdata = "lastindex";
        }

        this.datashowAll.push(item);
      });
      // console.log(this.datashowAll);
    },
    async exportToPDF(advance_id) {
      // this.$refs.html2Pdf.generatePdf();
      let element = document.getElementById("mydivhtmltobase");

      const opt = {
        margin: [0, 0, 0, 0],
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        // enableLinks: false,
        html2canvas: {
          scale: 2,
          dpi: 192,
          letterRendering: true,
          useCORS: true,
          // ignoreElements: (e) => {
          //   return e.classList.contains("cke_pagebreak") ||
          //     e.classList.contains("html2pdf__page-break")
          //     ? true
          //     : false;
          // },
        },
        jsPDF: {
          unit: "cm",
          format: "A4",
          orientation: "portrait",
          putOnlyUsedFonts: true,
          pagesplit: true,
        },
        // pagebreak: { mode: ["avoid-all"], after: ".cke_pagebreak" },
      };

      let abcd = await html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        // .output("bloburl")
        .then(function (pdf) {
          console.log(pdf);
          const totalPages = pdf.internal.getNumberOfPages();
          pdf.deletePage(totalPages);
          // var filtered = pdf.internal.pages.filter(function(el) {
          //   return el != null;
          // });

          // pdf.internal.pages = filtered;
          // for (let i = 0; i < totalPages; i++) {
          //   if (i == totalPages - 1) {
          //     pdf.internal.pages.splice(i, 1);
          //   }
          // }
          // pdf.addPage();

          // console.log(pdf);
          return pdf.output("bloburl");
        });
      // console.log(abcd);
      window.open(abcd);
      let blob = await fetch(abcd).then((r) => r.blob());
      // console.log(blob);
      // let formData = new FormData();
      // formData.append(`file`, blob, "test.pdf");
      // const resultadd = api.creatememoMaster(formData);
      // console.log(resultadd);

      // };
    },
    formatDatetomonthdayyear(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${month.padStart(2, "0")}/${day.padStart(2, "0")}/${year}`;
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
  },
  beforeCreate() {
    console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
};
</script>

<style scoped>
body {
  background: rgb(204, 204, 204);
}

.page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
}

.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

.page[size="A4"][layout="landscape"] {
  width: 29.7cm;
  height: 21cm;
}

.page[size="A3"] {
  width: 29.7cm;
  height: 42cm;
}

.page[size="A3"][layout="landscape"] {
  width: 42cm;
  height: 29.7cm;
}

.page[size="A5"] {
  width: 14.8cm;
  height: 21cm;
}

.page[size="A5"][layout="landscape"] {
  width: 21cm;
  height: 14.8cm;
}

@page {
  size: 7in 9.25in;
  margin: 27mm 16mm 27mm 16mm;
}

page {
  position: relative;
  background: white;
  display: block;
  margin: 0 auto;
  /* margin-bottom: 0.5cm; */
  border: 1px solid;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
}

page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

page[size="A4"][layout="portrait"] {
  width: 29.7cm;
  height: 21cm;
}

@media print {

  body,
  page {
    margin: 0;
    box-shadow: 0;
  }

  html,
  body {
    width: 210mm;
    height: 297mm;
  }
}

.page {
  display: inline-block;
  position: relative;
  height: 297mm;
  width: 210mm;
  font-size: 12pt;
  margin: 2em auto;
  padding: calc(var(--bleeding) + var(--margin));
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
  background: white;
}

@media screen {
  .page::after {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: calc(100% - var(--bleeding) * 2);
    height: calc(100% - var(--bleeding) * 2);
    margin: var(--bleeding);
    /* outline: thin dashed black; */
    pointer-events: none;
    z-index: 9999;
  }
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.btnuploadfile {
  border: 2px solid;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred {
  width: 100%;
  background-color: #9e3b1b;
  color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonwhite {
  width: 100%;
  background-color: #f5f5f5;
  color: black;
}

h3 {
  font-size: 1.17em;
}

h4 {
  font-size: 1em;
}

.test {
  border-style: double;
}

.borderblack {
  border-style: solid;
  border-width: thin;
}

.mt-50 {
  margin-top: 50px;
}

.mb-50 {
  margin-bottom: 50px;
}

.btn-light {
  color: #333;
  background-color: #fafafa;
  border-color: #ddd;
}

@media (min-width: 768px) {
  .wmin-md-400 {
    min-width: 400px !important;
  }
}

.btn-primary {
  color: #fff;
  background-color: #2196f3;
}

.btn-labeled>b {
  position: absolute;
  top: -1px;
  background-color: blue;
  display: block;
  line-height: 1;
  padding: 0.62503rem;
}

.alignleft {
  float: left;
}

.alignright {
  float: right;
}

.aligncenter {
  text-align: center;
}

.captionreport {
  font-size: 0.85rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.caption {
  font-size: 0.75rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.captionhtable {
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.rowprpo {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  margin-right: -12px;
  margin-left: -12px;
}

.colprpo {
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  max-width: 100%;
}

.col-md-1report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 8.333333333333333%;
  flex: 0 0 8.333333333333333%;
  max-width: 8.333333333333333%;
}

.col-md-2report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 16.66666666666667%;
  flex: 0 0 16.66666666666667%;
  max-width: 16.66666666666667%;
}

.col-md-3report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;
}

.col-md-4report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 33.33333333333333%;
  flex: 0 0 33.33333333333333%;
  max-width: 33.33333333333333%;
}

.col-md-5report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 41.66666666666667%;
  flex: 0 0 41.66666666666667%;
  max-width: 41.66666666666667%;
}

.col-md-6report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.col-md-7report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 58.33333333333333%;
  flex: 0 0 58.33333333333333%;
  max-width: 58.33333333333333%;
}

.col-md-8report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 66.66666666666667%;
  flex: 0 0 66.66666666666667%;
  max-width: 66.66666666666667%;
}

.col-md-9report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 75%;
  flex: 0 0 75%;
  max-width: 75%;
}

.col-md-10report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 83.33333333333333%;
  flex: 0 0 83.33333333333333%;
  max-width: 83.33333333333333%;
}

.col-md-11report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 91.66666666666667%;
  flex: 0 0 91.66666666666667%;
  max-width: 91.66666666666667%;
}

.col-md-12report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}

.mt-30prpo {
  margin-top: -30px !important;
}

.mt30 {
  margin-top: 30px !important;
}

.mt10 {
  margin-top: 10px !important;
}

.mt25 {
  margin-top: 25px !important;
}

.mt-25prpo {
  margin-top: -25px !important;
}

.mr30prpo {
  margin-right: 30px !important;
}

.ml30prpo {
  margin-left: 30px !important;
}

.ml2prpo {
  margin-left: 2px !important;
}

.ml10prpo {
  margin-left: 10px !important;
}

.borderblockpr {
  border: 2px solid black;
  width: 100px;
  height: 150px;
  background: white;
  box-sizing: border-box;
  display: inline-block;
}

.col-md-4pr {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 30%;
  flex: 0 0 30%;
  max-width: 30%;
}

.col-md-8pr {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 70%;
  flex: 0 0 70%;
  max-width: 70%;
}

.col-md-4prrd {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.col-md-8prrd {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.textalignleft {
  text-align: left;
}

.textalignright {
  text-align: right;
}

table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  /* border: 1px solid black; */
}

.prbordertop {
  border-top: 1px solid black;
}

.prborderbottom {
  border-bottom: 1px solid black;
}

.prbordertop2pxhtable {
  padding-top: 8px;
  border-top: 2px solid black;
}

.prborderbottom2pxhtable {
  padding-bottom: 8px;
  border-bottom: 2px solid black;
}

td {
  /* border: 1px solid black; */
}

.width15 {
  word-wrap: break-word;
  width: 15%;
}

.width10 {
  word-wrap: break-word;
  width: 10%;
}

.width20 {
  word-wrap: break-word;
  width: 20%;
}

.width30 {
  word-wrap: break-word;
  width: 30%;
}

.width40 {
  word-wrap: break-word;
  width: 40%;
}

.width50 {
  word-wrap: break-word;
  width: 50%;
}

.width60 {
  word-wrap: break-word;
  width: 60%;
}

.width70 {
  word-wrap: break-word;
  width: 70%;
}

.width90 {
  word-wrap: break-word;
  width: 90%;
}

.width100 {
  word-wrap: break-word;
  width: 100%;
}

@media print {

  /*
                body.A3.landscape { width: 420mm }
                body.A3, body.A4.landscape { width: 297mm }
                body.A4, body.A5.landscape { width: 210mm }
                body.A5 { width: 148mm }*/
  .printonly {
    display: block;
  }

  .noprint {
    display: none;
  }

  .A3.landscape {
    width: 420mm;
  }

  .A3,
  .A4.landscape {
    width: 297mm;
  }

  .A4,
  .A5.landscape {
    width: 210mm;
  }

  .A5 {
    width: 148mm;
  }
}

header {
  top: 0;
  padding-top: 150mm;
  padding-bottom: 3mm;
}

footer {
  bottom: 0;
  color: #000;
  padding-top: 3mm;
  padding-bottom: 5mm;
}

header,
footer {
  /* position: fixed; */
  left: 0;
  right: 0;
  background-color: #ccc;
  padding-right: 1.5cm;
  padding-left: 1.5cm;
}

.footerprpo {
  position: absolute;
  bottom: 10px;
  width: 90%;
}

.borderauto {
  border: 1px solid;
  margin: -1px;
}

.bordersignature {
  height: 110px;
  border: 1px solid;
  margin: -1px;
}

.fixtworow {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 40px;
  overflow: hidden;
  text-align: left;
}

.fixonerow {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 20px;
  overflow: hidden;
  text-align: left;
}

.fontsize10 {
  font-size: 10px;
}

.color-orange {
  color: orange
}
</style>
